<template>
  <div class="blog-footer">
    <div class="blog-tags" v-if="tags && tags.length">
      <span class="tag-label">Tags:</span>
      <span v-for="(tag, index) in tags" :key="index" class="blog-tag">
        {{ tag }}
      </span>
    </div>

    <div class="share-section">
      <span class="share-label">Share this article:</span>
      <div class="share-icons">
        <vue-feather
          type="twitter"
          size="18"
          class="share-icon"
          @click="shareOnTwitter"
        ></vue-feather>
        <vue-feather
          type="facebook"
          size="18"
          class="share-icon"
          @click="shareOnFacebook"
        ></vue-feather>
        <vue-feather
          type="linkedin"
          size="18"
          class="share-icon"
          @click="shareOnLinkedIn"
        ></vue-feather>
        <vue-feather
          type="mail"
          size="18"
          class="share-icon"
          @click="shareByEmail"
        ></vue-feather>
      </div>
    </div>

    <RelatedArticles
      :related-blogs="relatedBlogs"
      @navigate-to-blog="handleNavigateToBlog"
    />

    <div class="back-to-blogs">
      <button class="blog-btn" @click="handleNavigateToBlogs">
        <vue-feather
          type="arrow-left"
          size="16"
          class="back-icon"
        ></vue-feather>
        Back to all blogs
      </button>
    </div>
  </div>
</template>

<script>
import RelatedArticles from "@/components/organisms/RelatedArticles.vue";

export default {
  name: "BlogFooter",
  components: {
    RelatedArticles,
  },
  props: {
    tags: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      required: true,
    },
    currentPageUrl: {
      type: String,
      required: true,
    },
    relatedBlogs: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    handleNavigateToBlog(blogId) {
      this.$emit("navigate-to-blog", blogId);
    },
    handleNavigateToBlogs() {
      this.$emit("navigate-to-blogs");
    },
    shareOnTwitter() {
      const text = `${this.title} - Check out this article by Skyhost`;
      const url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
        text
      )}&url=${encodeURIComponent(this.currentPageUrl)}`;
      window.open(url, "_blank");
    },
    shareOnFacebook() {
      const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
        this.currentPageUrl
      )}`;
      window.open(url, "_blank");
    },
    shareOnLinkedIn() {
      const url = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
        this.currentPageUrl
      )}`;
      window.open(url, "_blank");
    },
    shareByEmail() {
      const subject = encodeURIComponent(this.title);
      const body = encodeURIComponent(
        `I thought you might find this article interesting: ${this.title}\n\n${this.currentPageUrl}`
      );
      window.location.href = `mailto:?subject=${subject}&body=${body}`;
    },
  },
};
</script>

<style scoped>
.blog-footer {
  margin-top: 3rem;
  padding-top: 2rem;
  border-top: 1px solid #eee;
}

.blog-tags {
  margin-bottom: 2rem;
}

.tag-label {
  font-weight: 500;
  margin-right: 0.5rem;
}

.blog-tag {
  display: inline-block;
  padding: 0.3rem 0.8rem;
  margin: 0.3rem;
  background-color: #f0f0f0;
  border-radius: 20px;
  font-size: 0.9rem;
  color: #666;
}

.share-section {
  display: flex;
  align-items: center;
  margin-bottom: 3rem;
}

.share-label {
  font-weight: 500;
  margin-right: 1rem;
}

.share-icons {
  display: flex;
  gap: 1rem;
}

.share-icon {
  cursor: pointer;
  color: #555;
}

.share-icon:hover {
  color: #1565c0;
}

.back-to-blogs {
  margin-top: 3rem;
  text-align: center;
}

.blog-btn {
  display: inline-flex;
  align-items: center;
  padding: 0.8rem 1.5rem;
  background-color: #f0f0f0;
  border: none;
  border-radius: 30px;
  font-size: 1rem;
  font-weight: 500;
  color: #333;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.blog-btn:hover {
  background-color: #e0e0e0;
}

.back-icon {
  margin-right: 0.5rem;
}
</style>
